<my-bill-odb-page-base-structure
  [billingDocument]="billDocument"
  [customTitle]="headerTitle | translate"
  [hasCommonHeader]="true"
  *ngIf="
    (billCover$ | async) !== null && !(billCover$ | async).isFetching;
    else showSkeleton
  "
>
  <!--///////////////   LEFT Column content   //////////////////-->
  <span leftColumnContent>
    <my-bill-odb-bill-document-explanation-intro
      [billingDocument]="billDocument"
      [accountNumber]="billingAccount.accountNumber"
    ></my-bill-odb-bill-document-explanation-intro>
    <ng-container
      *ngIf="
        (billCover$ | async).result !== null && !(billCover$ | async).hasError;
        else showError
      "
    >
      <span
        *ngFor="
          let coverDetail of (billCover$ | async).result?.coverDetails;
          index as i
        "
      >
        <my-bill-cover-details
          [coverDetail]="coverDetail"
          [testIDPrefix]="'coverDetail_' + i"
          (detailsClick)="onDetailsClick($event)"
        >
        </my-bill-cover-details>
      </span>
      <p class="rs-txt-details" data-cy="myBillCoverSentenceRoundedAmount">
        {{ 'bills.cover.roundedAmountDescription' | translate }}
      </p>
      <div
        class="panel rs-bg-primary rs-margin-bottom2-s rs-margin-bottom4-m"
        my-bill-odb-total
        [showVatText]="true"
        [amount]="billDocument.totalAmount"
        [attr.data-cy]="testIDPrefix + '_total'"
      ></div>
      <my-bill-download-card
        [billDocument]="billDocument"
        [customerId]="selectedCustomer?.customerId"
        [billingAccount]="billingAccount"
        [buttonZone]="'mybill.detail'"
      ></my-bill-download-card>
    </ng-container>
    <ng-template #showError>
      <div class="rs-bg-c2 rs-radius">
        <lib-generic-message-box
          [messageType]="messageBoxTypeError"
          [showCross]="false"
        >
          <ng-container Title>{{
            'bills.cover.serviceUnavailable.title' | translate
          }}</ng-container>
          <p Content>
            {{ 'bills.cover.serviceUnavailable.message' | translate }}
          </p>
        </lib-generic-message-box>
      </div>
    </ng-template>
  </span>

  <!--///////////////   RIGHT Column content   //////////////////-->
  <span rightColumnContent>
    <div
      class="rs-panel-big rs-bg-c2"
      *ngIf="
        customerPaymentProfile &&
        (billCover$ | async).result !== null &&
        !(billCover$ | async).hasError
      "
    >
      <my-bill-options
        [billingAccount]="billingAccount"
        [billDocument]="billDocument"
        [customerPaymentProfile]="customerPaymentProfile"
      >
      </my-bill-options>
    </div>
  </span>
</my-bill-odb-page-base-structure>
<ng-template #showSkeleton>
  <my-bill-odb-page-base-structure
    [billingDocument]="billDocument"
    hasCommonHeader="false"
    hasTopContent="true"
  >
    <my-bill-overview-redesign-skeleton topContent>
    </my-bill-overview-redesign-skeleton>
  </my-bill-odb-page-base-structure>
</ng-template>
